
import { Component, Prop, Vue, } from 'vue-property-decorator';
import ProgressStepsV2 from '~/components/progress-steps-v2/progress-steps-v2.vue';

@Component({
	components: {
		ProgressStepsV2,
	},
})
export default class RegisterationProgressSteps extends Vue {
	@Prop({
		type: Number,
		required: true,
	})
	currentStep!: number;

	@Prop({
		type: Array,
		required: true,
	})
	progressStepsLabels!: string[];

}
